module.exports = __webpack_public_path__ + "static/media/5MyHealth.0e4796e9.JPG";